module.exports = __webpack_public_path__ + "static/img/14.e960ad7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/14.png
// module id = rUV1
// module chunks = 0